module.exports = __webpack_public_path__ + "img/TechMarketExchance2_ua.8f8f134a.webp";